import axios from "./index";

//route to fetch all batches
export async function fetch(params) {
  return axios.post("prabandhak/batch/list", params).then((res) => res.data);
}
